import angular from 'angular';

class activitiesCtrl {
  /* @ngInject */
  constructor(ActivityService) {
    this.ActivityService = ActivityService;
  }

  $onInit() {
    this.criterias = { process: [], name: [] };
    this.activities = this.ActivityService.findAll();
  }

  changeActivityStatus(process, name) {
    this.criterias.process = process;
    this.criterias.name = name;
    this.ActivityService.changeActivityStatus(this.criterias, (/*data*/) => {
      angular.forEach(this.activities, activity => {
        if (activity.process === process && activity.name === name) {
          activity.status = activity.status === 'STARTED' ? 'STOPPED' : 'STARTED';
        }
      });
    });
  }
}

angular.module('epdf.admin.activities').component('activities', {
  templateUrl: require('./activities.html'),
  controller: activitiesCtrl
});
